import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchApi, getImage } from "../../../helper/api";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { IsAlert } from "../../atoms/IsAlert";
import Switch from "@mui/material/Switch";
import $ from "jquery";
import { connect } from "react-redux";
import { isRoleHasAcces } from "../../../helper/function";
import { engineer, superUser } from "../../../helper/constantRole";

const label = { inputProps: { "aria-label": "Switch Aksi" } };
const DetailJembatan = (props) => {
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    if (props?.idJembatan) {
      getdata();
      // props.openEdit();
    }
  }, [props]);

  const [dataJembatan, setDataJembatan] = useState();

  const getdata = async () => {
    const req = await fetchApi(
      `api/Bridge/details/${props?.idJembatan}`,
      "get",
      true
    );
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      setDataJembatan(res.data);
    }
  };

  const deletJembatan = async (id) => {
    const req = await fetchApi(`api/Bridge/delete/${id}`, "delete", true);
    const status = req.status;
    if (status === 200) {
      props.callback();
    } else {
    }
    $(".close-jembatan").click();
  };

  const handleUsable = async () => {
    const req = await fetchApi(
      `api/Bridge/switchUsable/${props?.idJembatan}`,
      "GET",
      true
    );
    const status = req.status;
    getdata();
  };
  const handleVisible = async () => {
    const req = await fetchApi(
      `api/Bridge/switchVisible/${props?.idJembatan}`,
      "GET",
      true
    );
    const status = req.status;
    getdata();
  };

  return (
    <div
      className="modal fade"
      id="detailJembatan"
      // tabIndex={-1} // MAKE EDIT POP UP EDITABLE
      aria-labelledby="SettingTreshold_modalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div>
              <h3 className="mb-0">
                <b>{dataJembatan?.namaJembatan}</b>
              </h3>
              <p>nomor jembatan: {dataJembatan?.nomorJembatan}</p>
            </div>
            <div className="d-flex" style={{ gap: "20px" }}>
              {isRoleHasAcces([engineer, superUser], props._dataProfile.role) && (
                <>
                  <span
                    onClick={() => {
                      IsAlert.fire({
                        title: "Konfirmasi Hapus Jembatan",
                        text: "Hapus " + dataJembatan?.namaJembatan + " ?",
                        icon: "question",
                        showCancelButton: true,
                        focusConfirm: true,
                        confirmButtonText: "Hapus",
                      }).then(function (isConfirm) {
                        if (isConfirm.isConfirmed) {
                          deletJembatan(dataJembatan?._id);
                        }
                      });
                    }}
                    className="btn bg-danger rounded-round shadow p-2 m-0"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className="las la-trash-alt"
                      style={{ fontSize: 20, color: "white" }}
                    ></i>
                  </span>
                  <span
                    onClick={() => {
                      props.changeTypeDialog();
                      props.openEdit();
                    }}
                    className="btn rounded-round shadow p-2 m-0"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className="las la-cog text-dark"
                      style={{ fontSize: 20 }}
                    ></i>
                  </span>
                </>
              )}
            </div>
          </div>
          <div className="modal-body py-4">
            <img
              className="w-100 mb-2"
              src={getImage(dataJembatan?.imgPath)}
              alt="bridge"
              height={300}
              style={{
                backgroundColor: "transparent",
                objectFit: "contain",
              }}
            />
            <div className="row">
              {isRoleHasAcces([engineer, superUser], props._dataProfile.role) && (
                <>
                  <div className="col-lg-12 mb-2">
                    <div className="shadow rounded p-2 d-flex justify-content-between align-items-center">
                      <div>
                        <p className="mb-0">Visible</p>
                        <h5 className="mb-0">
                          {dataJembatan?.isVisible ? "Ya" : "Tidak"}
                        </h5>
                      </div>
                      <Switch
                        {...label}
                        checked={dataJembatan?.isVisible ? true : false}
                        onChange={() => handleVisible()}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 mb-2">
                    <div className="shadow rounded p-2 d-flex justify-content-between align-items-center">
                      <div>
                        <p className="mb-0">Usable</p>
                        <h5 className="mb-0">
                          {dataJembatan?.isUsable ? "Ya" : "Tidak"}
                        </h5>
                      </div>
                      <Switch
                        {...label}
                        checked={dataJembatan?.isUsable ? true : false}
                        onChange={() => handleUsable()}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-lg-12 mb-2">
                <div className="shadow rounded p-2">
                  <p className="mb-0">Alamat Lengkap</p>
                  <h5 className="mb-0">{dataJembatan?.alamatLengkap}</h5>
                </div>
              </div>
              <div className="col-lg-6 mb-2">
                <div className="shadow rounded p-2">
                  <p className="mb-0">Provinsi</p>
                  <h5 className="mb-0">{dataJembatan?.provinsi}</h5>
                </div>
              </div>
              <div className="col-lg-6 mb-2">
                <div className="shadow rounded p-2">
                  <p className="mb-0">Kabupaten / Kota</p>
                  <h5 className="mb-0">{dataJembatan?.kabkota}</h5>
                </div>
              </div>
              <div className="col-lg-6 mb-2">
                <div className="shadow rounded p-2">
                  <p className="mb-0">Konstruksi</p>
                  <h5 className="mb-0">{dataJembatan?.konstruksi}</h5>
                </div>
              </div>
              <div className="col-lg-6 mb-2">
                <div className="shadow rounded p-2">
                  <p className="mb-0">Panjang Jembatan</p>
                  <h5 className="mb-0">{dataJembatan?.panjang}</h5>
                </div>
              </div>
              <div className="col-lg-6 mb-2">
                <div className="shadow rounded p-2">
                  <p className="mb-0">Latitude</p>
                  <h5 className="mb-0">{dataJembatan?.latitude}</h5>
                </div>
              </div>
              <div className="col-lg-6 mb-2">
                <div className="shadow rounded p-2">
                  <p className="mb-0">Longitude</p>
                  <h5 className="mb-0">{dataJembatan?.longitude}</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer pt-3">
            <button
              type="button"
              className="btn btn-light close-jembatan"
              data-dismiss="modal"
            >
              Tutup
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={() => {
                $(".close-jembatan").click();
                navigate(
                  `/${props.tipe === "sensor" ? "sensor" : "structure"
                  }-monitor/${props?.idJembatan}`
                );
              }}
            >
              Advanced Detail
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapState = (state) => {
  return {
    _dataProfile: state.dataProfile
  };
};
export default connect(mapState)(DetailJembatan);
